import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';
import SearchField from '@amzn/meridian/search-field';
import React from 'react';

interface TopOptionsProps {
  searchField: string;
  setSearchField: (val: string) => void;
  onOpen: () => void;
}

const TopOptions = ({ searchField, setSearchField, onOpen }: TopOptionsProps) => {
  return (
    <Row widths={['fill', 'fit']} spacingInset="400 none" alignmentHorizontal="justify">
      <Row width={'grid-4'}>
        <SearchField value={searchField} onChange={setSearchField} placeholder="Search for..." onSubmit={() => {}} />
      </Row>

      <Button onClick={onOpen}>Add New Modification</Button>
    </Row>
  );
};

export default TopOptions;
